import * as z from 'zod';

export const nullableNumericQuerySchema = () => z.number().nullable();
export const numericStringFormSchema = () => z.string();
export const nullableNumericMutationSchema = () => z.number().nullable();

export const nullableNumericToNumericStringConverter = (value: number | null) => {
  return value?.toString() ?? '';
};

export const cleanNumericString = (value: string) => {
  return (value || '').replace(/[^0-9.-]/g, '');
};

export const nullableStringToNullableIntConverter = (value?: string | null) => {
  if (typeof value === 'undefined' || value === null) {
    return null;
  }
  const nValue = cleanNumericString(value);
  return nValue === '' ? null : parseInt(nValue);
};

export const nullableStringToNullableFloatConverter = (value?: string | null) => {
  if (typeof value === 'undefined' || value === null) {
    return null;
  }
  const nValue = `${value ?? ''}`.replace(/[^0-9.-]/g, '');
  return nValue === '' ? null : parseFloat(nValue);
};

export function numericIntSchema() {
  return z.int();
}

export function numericIntSchemaWithValidation(min = 0, max = Number.MAX_VALUE) {
  return z
    .int()
    .refine((val) => val > min, { message: 'Please enter a value greater than ' + min })
    .refine((val) => val < max, { message: 'Please enter a value lesser than ' + Number.MAX_VALUE });
}
